(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-blog-posts"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class BlogPostsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      draggable: true
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }
}

document.querySelectorAll(`[data-pxu-blog-posts]`).forEach(($section) => {
  Section.init($section, BlogPostsSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.BlogPostsSection = BlogPostsSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-menu-list"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class MenuListSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.menus = this.$root.querySelectorAll('[data-pxu-menu-list-block]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this.initEventListeners();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.menus.forEach(el => {
      // Desktop accordian handling
      const trigger = el.querySelector('[data-pxu-menu-list-toggle]');
      if (trigger) {
        const overflowList = el.querySelector('[data-pxu-menu-list-overflow]');
        this.events.register(trigger, 'click', e => this.handleToggle(overflowList));
        this.events.register(overflowList, 'transitionend', e => {
          e.currentTarget.toggleAttribute('data-animating', false);
        });
      }

      // Mobile accordion handling
      const mobileTriggers = el.querySelectorAll('[data-pxu-menu-list-toggle-mobile]');
      const list = el.querySelector('[data-pxu-menu-list-content]');
      if (list.querySelector('li')) {
        mobileTriggers.forEach(mobileTrigger => {
          this.events.register(mobileTrigger, 'click', e => this.handleMobileToggle(e.currentTarget, list));
        });

        this.events.register(list, 'transitionend', e => {
          e.currentTarget.toggleAttribute('data-animating', false);
        });
      }
    });
  }

  handleToggle(overflowList) {
    let animateTo = 'data-hidden';
    let animateFrom = 'data-shown';

    overflowList.setAttribute('data-animating', true);

    if (overflowList.hasAttribute('data-hidden')) {
      animateTo = 'data-shown';
      animateFrom = 'data-hidden';

      let height = overflowList.scrollHeight;
      overflowList.style.setProperty('--pxu-hidden-menu-list-height', `${height}px`);
    }

    overflowList.toggleAttribute(animateTo, true);
    overflowList.toggleAttribute(animateFrom, false);
  }

  handleMobileToggle(target, list) {
    this.handleToggle(list);
    const menu = target.closest('[data-pxu-menu-list-menu-wrapper]');
    menu.querySelector('.pxu-menu-list__icon').toggleAttribute('data-closed');
    menu.querySelector('.pxu-menu-list__icon').toggleAttribute('data-open');
  }
}

document.querySelectorAll('[data-pxu-menu-list]').forEach(($section) => {
  Section.init($section, MenuListSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.MenuListSection = MenuListSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();
})();
